import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import helpers from '../util/helpers';

class AvatarPage extends Component {
  avatarClicked(face) {
    let faceNoDash = face.replace(/-/g,"");
    helpers.eventLog(`chooseAvatar - ${faceNoDash}`);

    let clone = this.refs[face].cloneNode(true);
    let position = this.refs[face].getBoundingClientRect();
    clone.style.width = (position.right - position.left) + 'px';
    clone.style.height = (position.bottom - position.top) + 'px';
    clone.style.position = 'absolute';
    clone.style.left = position.left + 'px';
    clone.style.top = (position.top + window.scrollY - 30) + 'px';
    clone.className += " animate";

    document.body.appendChild(clone);

    this.refs[face].style.visibility = 'hidden';

    // perhaps changing this order will make it less laggy
    let  that = this;
    setTimeout(function() {
      that.props.appState.changeAvatar(face);
      if (that.props.prevPage == "/login" && that.props.appState.loggedIn) {
        that.props.history.push(`/about`);
      } else {
        that.props.history.goBack()
      }
      window.scrollTo(0, 0);
      clone.remove();
    }, 1100);

    setTimeout(function() {
      clone.style.left = '10px';
      clone.style.top = '-20px';
      clone.style.height = '40px';
      clone.style.width = '40px';
    }, 50);


  }

  render() {
    window.scrollTo(0, 0);

    return (
      <div className="page avatar" ref='page'>
        <h2>
          <FormattedMessage id='app.pages.avatar.instructions' defaultMessage='Choose your avatar' />
        </h2>

        <p>
          <FormattedMessage id='app.pages.avatar.contents' defaultMessage="This face represents you in the report!" />
        </p>

        <div className="avatar-container">
          <img src={`${process.env.PUBLIC_URL}/images/face-1.png`} className='avatar' ref='face-1' onClick={() => this.avatarClicked('face-1')} alt='Avatar 1' />
          <img src={`${process.env.PUBLIC_URL}/images/face-5.png`} className='avatar' ref='face-5' onClick={() => this.avatarClicked('face-5')} alt='Avatar 5' />
          <img src={`${process.env.PUBLIC_URL}/images/face-2.png`} className='avatar' ref='face-2' onClick={() => this.avatarClicked('face-2')} alt='Avatar 2' />
          <img src={`${process.env.PUBLIC_URL}/images/face-3.png`} className='avatar' ref='face-3' onClick={() => this.avatarClicked('face-3')} alt='Avatar 3' />
          <img src={`${process.env.PUBLIC_URL}/images/face-4.png`} className='avatar' ref='face-4' onClick={() => this.avatarClicked('face-4')} alt='Avatar 4' />
          <img src={`${process.env.PUBLIC_URL}/images/face-6.png`} className='avatar' ref='face-6' onClick={() => this.avatarClicked('face-6')} alt='Avatar 6' />
          <img src={`${process.env.PUBLIC_URL}/images/face-7.png`} className='avatar' ref='face-7' onClick={() => this.avatarClicked('face-7')} alt='Avatar 7' />
        </div>
      </div>
    );
  }
}

export default AvatarPage;



// WEBPACK FOOTER //
// ./src/pages/AvatarPage.js